// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DPKH","title":"styles_title__cc6o_"};